import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export default function BlueBankIcon({ style }: { style?: { [key: string]: string } }) {
  return (
    <AccountBalanceIcon
      style={{
        color: '#0032C8',
        backgroundColor: 'rgba(149, 173, 253, 0.2)',
        width: '1.45em',
        height: '1.45em',
        padding: '0.2em',
        borderRadius: '5px',
        ...style,
      }}
    />
  );
}
